module.exports = __webpack_public_path__ + "img/house-solid.5f54bf83.svg";